<template>
  <div>
    <Pos_tax_refund />
  </div>
</template>
  
<script>
import Pos_tax_refund from "@/components/adminArin/pos_system/pos/Pos_paper_tax_refund";
export default {
  name: "PospaperTaxRefund",
  components: {
    Pos_tax_refund
  }
}
</script>
  
<style scoped></style>
  